import { TextareaHTMLAttributes } from 'react';
import { cn } from '@new/lib';

type DefaultValue = string | undefined;

export interface TextareaProps<T extends DefaultValue> extends Omit<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  'value' | 'onChange'
> {
  value: T;
  onChange: (value: T) => void;
  hasError?: boolean;
}

export const Textarea = <T extends DefaultValue>({
  value,
  onChange,
  hasError,
  className,
  ...rest
}: TextareaProps<T>) => {
  return (
    <textarea
      {...rest}
      value={value}
      onChange={(e) => onChange(e.target.value as T)}
      data-slot="textarea"
      className={cn(
        'l3! bg-(--neutral-white-NW800)! regular border-solid',
        'w-full min-h-37.5 p-4! rounded-md! border-2! resize-y',
        '[&&]:[font-family:var(--font-montserrat)]! [&&]:[font-size:var(--fs-l3)]! [&&]:leading(--lh-b)! [&&]:text-(--neutral-black-NB1000)!',
        'placeholder:[font-family:var(--font-montserrat)]!',
        'placeholder:[font-size:var(--fs-l4)]!',
        'xl:placeholder:[font-size:var(--fs-l3)]!',
        '[&::placeholder]:leading(--lh-b)!',
        'placeholder:text-(--neutral-white-NW600)!',
        'focus:border-(--neutral-black-NB1000)/80! focus:outline-none! focus:border-2!',
        hasError ? 'border-(--danger-D700)/80!' : 'border-transparent/80!',
        className
      )}
    />
  );
};
